var _rect, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCallNoAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 8,
    fill: "#EDE8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.44332 4.64069L8.01788 5.32361C8.81367 6.26742 8.73112 7.6894 7.82834 8.59226L7.33831 9.08167C7.20766 9.21256 7.16489 9.40739 7.22868 9.58098C7.40699 10.0684 7.86202 10.6774 8.59244 11.4078C9.32351 12.139 9.93242 12.5934 10.4191 12.7724C10.5928 12.836 10.7877 12.7929 10.9184 12.6621L11.4078 12.1727C12.3106 11.2698 13.7318 11.1866 14.6768 11.9811L15.3597 12.5564C16.139 13.2122 16.2182 14.3945 15.5354 15.1963C15.163 15.6271 14.6388 15.8977 14.0719 15.9518C11.8899 16.2458 9.60089 15.1943 7.20359 12.7968C4.80628 10.3993 3.75424 8.10946 4.04813 5.92794C4.0634 5.75725 4.09887 5.58897 4.15379 5.42664C4.28088 5.05374 4.50522 4.72153 4.80364 4.46434C5.60604 3.78208 6.78752 3.86068 7.44332 4.64069Z",
    fill: "url(#paint0_linear_1944_83507)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1944_83507",
    x1: 10,
    y1: 4,
    x2: 10,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC92ED",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC92ED"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallNoAvatar);
export default __webpack_public_path__ + "static/media/call_no_avatar.14b15d3dc78eb520cf61745a3a83111b.svg";
export { ForwardRef as ReactComponent };